// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import React, { useState } from 'react';
import clsx from 'clsx';
import {
    Dialog,
    DialogFooter,
    DialogType,
} from 'office-ui-fabric-react/lib/Dialog';
import { getId } from 'office-ui-fabric-react/lib/Utilities';
import { useTranslation } from 'react-i18next';

import { logPageAction } from 'src/lib/ApplicationInsights';
import Styles from './closeModal.module.scss';



export default function PartnerCommentModal(props: any) {
    const [hide, hideDialog] = useState(false);

    const { t } = useTranslation();

    function closeDialog() {
        logPageAction('Partner comment popup back button clicked');
        props.partnerCommentModalCloseClick();
        hideDialog(true);
    }

    const titleId: string = getId('partnerCommentDialogLabel');
    const subTextId: string = getId('partnerCommentSubTextLabel');

    return (
        <section>
            <Dialog
                hidden={hide}
                onDismiss={closeDialog}
                dialogContentProps={{
                    titleId,
                    subTextId,
                    type: DialogType.normal,
                    closeButtonAriaLabel: t('close'),
                    title: t('partner_comments'),
                    subText: props.partnerComments,
                }}
                modalProps={{
                    titleAriaId: titleId,
                    subtitleAriaId: subTextId,
                    isBlocking: true,
                    containerClassName: `${Styles.partnerPopup}`,
                }}
            >
                <DialogFooter>
                    <button
                        name="backBtn"
                        className={clsx(Styles.buttonSecondary, Styles.button)}
                        onClick={closeDialog}
                    >
                        {t('back')}
                    </button>
                </DialogFooter>
            </Dialog>
        </section>
    );
}
